import React, { useEffect, useRef, useState } from "react";
import Sidebar from "../../common/Sidebar/Sidebar";
import Header from "../../common/Header/Header";
import client from "../../services/Client";
import placeHolderIcon from "../../asessts/Images/PlaceHolder.svg";
import Loading from "../../common/Loading/Loading";
import toast from "react-hot-toast";
import Api from "../../services/Api";
import { MdDeleteForever } from "react-icons/md";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const MobileHome = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isBannerLoading, setIsBannerLoading] = useState(false);
  const [occasions, setOccasions] = useState([]);
  const [selectedOccasions, setSelectedOccasions] = useState([]);
  const [pictures, setPictures] = useState([]);
  const fileInputRef = useRef(null);

  const [editBanner, setEditBanner] = useState({
    id: "",
    bannerImage: [],
    content: "",
  });

  const fetchAdmin = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/app/admin/getBannerById/65e053d897d5124dee7c8114`
      );
      const bannerData = response.data.response;
      console.log("bannerData", bannerData);
      setEditBanner(() => ({
        id: bannerData.id,
        content: bannerData.content,
      }));
      const loadImages = bannerData?.bannerImage;

      if (loadImages && loadImages.length > 0) {
        setPictures(loadImages.map((url) => ({ url })));
      }
      setIsLoading(false);
    } catch (error) {
      console.log("Error fetching banner data ", error);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchOccasion = async () => {
    setIsLoading(true);
    try {
      const response = await Api.get_occasion_data();
      const fetchedOccasions = response?.data?.response || [];
      const initialSelectedOccasions = fetchedOccasions.map((occasion) => ({
        id: occasion.id,
        name: occasion.name,
        status: occasion.isDisplayOnHomePage,
      }));
      setOccasions(initialSelectedOccasions);
      setSelectedOccasions(initialSelectedOccasions);
    } catch (error) {
      console.log("Error fetching admin", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAdmin();
    fetchOccasion();
  }, []);

  const handleDivClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleChange = (event) => {
    const files = Array.from(event.target.files);
    const newPictures = files.map((file) => ({
      url: URL.createObjectURL(file),
      file,
    }));
    if (newPictures.length + pictures.length <= 5) {
      setPictures((prev) => [...prev, ...newPictures]);
    } else {
      toast.error("You can only upload a maximum of 5 images");
    }
  };

  const handleDelete = (index) => {
    setPictures((prev) => prev.filter((_, i) => i !== index));
  };

  const updateAdminData = async (e) => {
    e.preventDefault();
    try {
      setIsBannerLoading(true);
      const formData = new FormData();
      for (const key in editBanner) {
        formData.append(key, editBanner[key]);
      }
      pictures.forEach((img) => {
        if (img.file) {
          formData.append("bannerImage", img.file);
        } else {
          formData.append("bannerImage", img.url);
        }
      });
      await Api.updateBanner(formData);
      toast.success("Successfully updated Banner");
    } catch (error) {
      console.error("Error updating admin data:", error);
      toast.error("Failed to update banner. Please try again.");
    } finally {
      setIsBannerLoading(false);
    }
  };

  const handleCheckboxToggle = (id) => {
    setSelectedOccasions((prev) =>
      prev.map((occasion) =>
        occasion.id === id
          ? { ...occasion, status: !occasion.status }
          : occasion
      )
    );
  };

  const updateOccasion = async (e) => {
    e.preventDefault();
    try {
      setIsBannerLoading(true);
      const updatedOccasions = selectedOccasions.map((occasion, index) => ({
        occasionId: occasion.id,
        display: occasion.status,
        orderNo: index + 1,
      }));

      const data = { ocasionDetails: updatedOccasions };
      await Api.update_occasion_data(data);
      toast.success("Successfully updated Occasions");
    } catch (error) {
      console.error("Error updating occasions:", error);
      toast.error("Failed to update Occasions. Please try again.");
    } finally {
      setIsBannerLoading(false);
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(selectedOccasions);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setSelectedOccasions(items);
  };

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <div className="main-dashboard subadmin-dashboard">
        <Header title={"Mobile Home"} />
        {isLoading ? (
          <Loading />
        ) : (
          <div className="loaction-list-main mobile-list-main">
            <div className="setting-main mobile-home-main">
              <div className="setting-details">
                <h3>Banner Image and Content</h3>
                <div className="basic-detail">
                  <div className="profile-details">
                    <div className="input-group">
                      <div className="input-field">
                        <label>Content</label>
                        <textarea
                          placeholder="Happy Christmas!"
                          value={editBanner.content}
                          onChange={(e) =>
                            setEditBanner({
                              ...editBanner,
                              content: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="profile-upload banner-image-new">
                  {pictures.length > 0 && (
                    <div className="profile-img">
                      {pictures.map((picture, index) => (
                        <div key={index} className="relative">
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              borderRadius: "10px",
                            }}
                            src={picture.url}
                            alt={`Profile ${index + 1}`}
                          />
                          <button
                            type="button"
                            onClick={() => handleDelete(index)}
                          >
                            <MdDeleteForever
                              style={{ color: "red", fontSize: "25px" }}
                            />
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                  {pictures.length < 5 && (
                    <div className="upload-img-mobile" onClick={handleDivClick}>
                      <button>
                        <img src={placeHolderIcon} alt="placeholder_icon" />
                      </button>
                      <input
                        type="file"
                        onChange={handleChange}
                        multiple
                        accept="image/*"
                        ref={fileInputRef}
                        className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
                      />
                    </div>
                  )}
                </div>
                <div
                  className="save-btn"
                  onClick={updateAdminData}
                  disabled={isBannerLoading}
                >
                  <button>
                    {isBannerLoading ? (
                      <div className="upload_loader"></div>
                    ) : (
                      "Update"
                    )}
                  </button>
                </div>
              </div>

              <div className="add-area-info">
                <h3>
                  List of Occasions
                  <span> (Drag and drop to change the order)</span>
                </h3>
                <div className="streent-areas-select">
                  <div className="street-area-left">
                    <DragDropContext onDragEnd={onDragEnd}>
                      <Droppable droppableId="occasions">
                        {(provided) => (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                          >
                            {selectedOccasions.map((occasion, index) => (
                              <Draggable
                                key={occasion.id}
                                draggableId={occasion.id}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    className="street-label"
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                  >
                                    <input
                                      type="checkbox"
                                      checked={occasion.status}
                                      onChange={() =>
                                        handleCheckboxToggle(occasion.id)
                                      }
                                    />
                                    <label>{occasion.name}</label>
                                  </div>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>
                  </div>
                </div>

                <div
                  className="add-area-btn"
                  onClick={updateOccasion}
                  disabled={isBannerLoading}
                >
                  <button>
                    {isBannerLoading ? (
                      <div className="upload_loader"></div>
                    ) : (
                      "Update"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileHome;
